import { useMutation } from '@tanstack/react-query';
import { format } from 'date-fns';

import { endpoints } from 'global/endpoints';
import downloadHttp from 'utils/reportDownloads';

const downloadWhoIsWorking = () => {
  const newEndpoints = endpoints.reports.downloadWhoIsWorking;
  const filename = `who-is-working-${format(new Date(), 'yMdHms')}.csv`;

  return downloadHttp().lpostcsv(newEndpoints, {}, filename);
};

export function useDownloadWhoIsWorking() {
  return useMutation({ mutationFn: downloadWhoIsWorking });
}
